import React, { useState, useEffect } from 'react';
import AISummaryModal from '../../../../../RayCustomControls/AIContent/AISummaryModal';
import { AINewsType } from '../../../../../Constants/AINewsConstants';


const TrackPriceAINews = ({
  mousePosition,
  screenWidth,
  screenHeight,
  isTopAlign,
  isLeftAlign,
  trackPriceAINews,
  trackPriceRef,
  show,
  trackPriceDate,
}) => {

  const [target, setTarget] = useState(null);
  const [overlayPosition, setOverlayPosition] = useState(null);

  const TRACK_PRICE_AI_WIDTH = 400;
  const TRACK_PRICE_AI_HEIGHT = 250;
  const offset = 15;


  useEffect(() => {
    if (!trackPriceRef) return;
    setTarget(trackPriceRef);

    const refBlockHeight = trackPriceRef.getBoundingClientRect().height;

    // Determine horizontal placement of overlay
    let aiPopupPosition = {};
    let maxHeight = TRACK_PRICE_AI_HEIGHT;

    const finalLeft = isLeftAlign
      ? mousePosition.x - (TRACK_PRICE_AI_WIDTH + offset)
      : mousePosition.x + offset;
    aiPopupPosition.left = finalLeft;

    let finalYPosition;
    let spaceAbove, spaceBelow, canPlaceBelow;

    if (isTopAlign) {
      spaceBelow = screenHeight - (mousePosition.y + offset);
      canPlaceBelow = spaceBelow >= TRACK_PRICE_AI_HEIGHT;
      spaceAbove = mousePosition.y - (refBlockHeight + 2 * offset);

      if (canPlaceBelow) {
        finalYPosition = mousePosition.y + offset;
        aiPopupPosition.top = finalYPosition;
      } else {
        const hasMoreSpaceAbove = spaceAbove > spaceBelow;
        maxHeight = Math.max((hasMoreSpaceAbove ? spaceAbove : spaceBelow) - 4, 0);
        if (hasMoreSpaceAbove) {
          finalYPosition = screenHeight - mousePosition.y + refBlockHeight + 2 * offset;
          aiPopupPosition.bottom = finalYPosition;
        } else {
          finalYPosition = mousePosition.y + offset;
          aiPopupPosition.top = finalYPosition;
        }
      }
    } else {
      spaceBelow = screenHeight - (mousePosition.y + refBlockHeight + 2 * offset);
      canPlaceBelow = spaceBelow >= TRACK_PRICE_AI_HEIGHT;
      spaceAbove = mousePosition.y - offset;

      if (canPlaceBelow) {
        finalYPosition = mousePosition.y + refBlockHeight + 2 * offset;
        aiPopupPosition.top = finalYPosition;
      } else {
        const hasMoreSpaceAbove = spaceAbove > spaceBelow;
        maxHeight = Math.max((hasMoreSpaceAbove ? spaceAbove : spaceBelow) - 4, 0);
        if (hasMoreSpaceAbove) {
          finalYPosition = screenHeight - mousePosition.y + offset;
          aiPopupPosition.bottom = finalYPosition;
        } else {
          finalYPosition = mousePosition.y + refBlockHeight + 2 * offset;
          aiPopupPosition.top = finalYPosition;
        }
      }
    }

    setOverlayPosition({
      ...aiPopupPosition,
      maxHeight: Math.min(maxHeight, TRACK_PRICE_AI_HEIGHT),
    });
  }, [mousePosition, screenWidth, screenHeight, trackPriceRef, isTopAlign, isLeftAlign]);


  return (
    <>
      {show &&
        <AISummaryModal
          target={target}
          showPopup={show}
          hidePopup={() => { }}
          data={trackPriceAINews}
          popoverPosition={overlayPosition}
          className="trackprice-ai-news"
          newsType={AINewsType.TRACK_PRICE_AI_NEWS}
          width="400px"
          trackPriceDate={trackPriceDate}
        />}
    </>
  );
};


export default TrackPriceAINews;
